import { WebClient } from './server/WebClient';

export interface SermonGeniusSearchItem {
    id?: string;
    title: string;
    contributor?: string;
    description: string;
    rating?: number;
    scriptureReference?: string,
    summary?: string
}

export interface GeniusSearchRequest {
    title: string,
    keywords?: string[];
    scriptureRefs?: string[];
    translationId?: string;
}


export const GeniusSearchService = {
    findBibleVerses: (request: GeniusSearchRequest) => WebClient.Post.Unvalidated<SermonGeniusSearchItem[]>(`/api/GeniusSearch/FindBibleVerses`, request),
    findSermonIllustrations: (request: GeniusSearchRequest) => WebClient.Post.Unvalidated<SermonGeniusSearchItem[]>( `api/GeniusSearch/FindSermonIllustrations`, request),
    findSermons: (request: GeniusSearchRequest) => WebClient.Post.Unvalidated<SermonGeniusSearchItem[]>(`api/GeniusSearch/FindSermons`, request),
    blockSermonIllustration: (sermonIllustrationId:string) => WebClient.Post.Unvalidated(`api/GeniusSearch/BlockSermonIllustration`, { Id: sermonIllustrationId }),
    blockSermon: (sermonId:string) => WebClient.Post.Unvalidated(`api/GeniusSearch/BlockSermon`, {Id: sermonId})
}